import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.apiUrl}`;

class ConferenceAndTradeMission {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }
  getGuestHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  async getConferenceAndTradeMission() {
    try {
      const response = await axios.get(
        `${BASE_URL}/events/conferences`,
        this.getGuestHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason ||
          "Conference and trade mission fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.message ||
          "An error occurred while getting conference and trade mission",
      };
    }
  }

  async getEventDetails(event_slug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/events/get/${event_slug}`,
        this.getGuestHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.message || "Event details fetched successfully",
      };
    } catch (error) {
      const errorData =
        error?.response?.data?.message || error?.response?.message;
      let errorMessage = "An Error Occurred While Getting Event Details";

      if (errorData) {
        errorMessage = errorData;
      }

      return {
        status: false,
        data: null,
        message: errorMessage,
      };
    }
  }

  async registerTradeMission(payload){
    try{
      const response = await axios.post(
        `${BASE_URL}/user/events/create`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data.data,
        message:response.data.message || "Trade mission registered successfully",
      }
    }catch(error){
      const reason = error.response?.data?.reason;
      const message = error.response?.data?.message;
      return {
        status:false,
        data:error.response?.data ?? null,
        message: reason || message || "An error occurred while registering.",
      }
    }
  }
  async getAllRegisteredEvents(event_type){
    try{
      const response = await axios.get(
        `${BASE_URL}/user/events/all?flt=${event_type}`,
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data.data,
        message:response.data.message || "All registered events fetched successfully",
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error.response?.data?.message || "An error occurred while getting all registered events",
      }
    }
  }

  async verifyPaymentStatus(registrationId){
    try{
      const response = await axios.get(
        `${BASE_URL}/user/payment/verify/${registrationId}`,
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data.data,
        message:response.data.message || "Payment status verified successfully",
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error.response?.data?.message || "An error occurred while verifying payment status",
      }
    }
  }

  async manualPaymentConfirmation(registrationId){
    try{
      const response = await axios.post(
        `${BASE_URL}/user/payment/manual-verify`,
        { registration_id: registrationId },
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data.data,
        message:response.data.message || "Manual payment confirmation submitted successfully",
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error.response?.data?.message || "An error occurred while submitting manual payment confirmation",
      }
    }
  }

  async validateAgentReferral(referralCode){
    try{
      const response = await axios.post(
        `${BASE_URL}/agent/referral/validate`,
        { referral_code: referralCode },
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data,
        message:response.data.message || "Referral code validated successfully",
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error.response?.data?.message || "An error occurred while validating referral code",
      }
    }
  }

  async processPayment(payload){
    try{
      const response = await axios.post(
        `${BASE_URL}/user/payment/process`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data,
        message:response.data.message || "Payment processed successfully",
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error.response?.data?.message || "Payment processing failed",
      }
    }
  }

  async payConference(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/payment/conference`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data,
        message: response.data?.message || response.data?.reason || "Conference payment initiated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.message ||
          error.response?.data?.reason ||
          "Conference payment initiation failed",
      };
    }
  }

  /**
   * Create event ticket booking and initiate payment.
   * POST /user/payment/ticket - for event types that require ticket booking.
   * Payload: event_slug, ticket_name, quantity, payment_method, guests, momo_provider, momo_phone.
   * Response will contain a link to the payment gateway for finalization.
   */
  async createEventBooking(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/payment/ticket`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data,
        message: response.data?.reason || response.data?.message || "Event booking created successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.reason ||
          error.response?.data?.message ||
          "Event booking failed",
      };
    }
  }

  /**
   * Process payment for a regular event ticket booking (legacy).
   * Separate from conference/trade-mission payments.
   */
  async processEventPayment(payload){
    try{
      const response = await axios.post(
        `${BASE_URL}/user/events/payment/process`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status:true,
        data:response.data,
        message:response.data.message || "Event payment processed successfully",
      }
    }catch(error){
      return {
        status:false,
        data:null,
        message:error.response?.data?.message || "Event payment processing failed",
      }
    }
  }
}
const conferenceAndTradeMissionService = new ConferenceAndTradeMission();
export default conferenceAndTradeMissionService;
